import { Router } from '@angular/router';
import { drawerListItem } from './../../../core/interfaces/drawer-list.interface';
import { Subscription } from 'rxjs';
import { InteractionService } from './../../../core/services/interaction.service';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-create-vacancy',
  templateUrl: './create-vacancy.component.html',
  styleUrls: ['./create-vacancy.component.sass']
})
export class CreateVacancyComponent implements OnInit, OnDestroy {

  $vacancyFormsSubscription:Subscription;
  vacancyInteractionForms:drawerListItem[] = [];
  showFormsDrawer:boolean = false;

  constructor(private interactionService: InteractionService, private router: Router) {}

  ngOnInit(): void {
    // Enable when ready
    //this.getVacancyInteractionForms();
  }

  getVacancyInteractionForms(){
    this.$vacancyFormsSubscription = this.interactionService.getJobInsertionForms().subscribe(res => {
      if(res){
        let interactionFormList = [];
        res.forEach(function(formItem){
          interactionFormList.push({
            title: formItem.name,
            icon: '<i class="fa-solid fa-pen-field"></i>',
            uid: formItem.uid
          });
        });
        this.vacancyInteractionForms = interactionFormList;
      }
    });
  }


  onShowForms(){
    this.showFormsDrawer = true;
  }

  onUpdateDrawerState(newstate:boolean){
    this.showFormsDrawer = newstate;
  }

  onDrawerItemClicked(formId:number){
    this.router.navigate(['/interactions/' + formId]);
  }

  ngOnDestroy(): void {
    if(this.$vacancyFormsSubscription){
      this.$vacancyFormsSubscription.unsubscribe();
    }
  }
}
